import React from "react";
import { Box, Stack } from "@material-ui/core";
import { AppWidgets1 } from "../_dashboard/general-app";
import { decryptData } from "src/utils/decryptcookie";
import { Container } from "@mui/material";
import { navigateByRole } from "src/utils/roles/roles-condition";

const HeaderWithRole = () => {
  const user = decryptData("_b60-g6fr_plus");
  const navigateTo = navigateByRole(user?.role)
  return (
    <Container
      maxWidth="xl"
      sx={{
        "@media (min-width: 1280px)": {
          maxWidth: "1400px",
        },
      }}
    >
      <Stack className="d-flex justify-between items-center flex-row py-2 ">
        <a href={navigateTo}>
          <Box sx={{ width: 150 }}>
            <img src="/static/brand/Travomint.png" class="img 2" alt="login" />
          </Box>
        </a>
        <Stack
          direction="row-reverse"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          <AppWidgets1 />
        </Stack>
      </Stack>
    </Container>
  );
};

export default HeaderWithRole;
